import { ApplicationConfig } from '@angular/core';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withHashLocation,           
} from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';

import { appRoutes } from './app.routes';
import { AuthInterceptor } from '@/interceptors/auth.interceptor';

/** ---------- PRIME NG THEME PRESET ---------- 
 * Algunos proyectos marcan error de tipos al pasar el objeto 'semantic'.
 * Forzamos el tipo con 'as const' y un cast a 'any' en definePreset.
 */
const MyPreset = definePreset(Aura as any, {
  semantic: {
    primary: {
      50: '{sky.50}', 100: '{sky.100}', 200: '{sky.200}', 300: '{sky.300}',
      400: '{sky.400}', 500: '{sky.500}', 600: '{sky.600}', 700: '{sky.700}',
      800: '{sky.800}', 900: '{sky.900}', 950: '{sky.950}',
    },
    overlay: {
      modal: { borderRadius: '1.5rem' },
      popover: { borderRadius: '10px' },
    },
    colorScheme: {
      light: {
        surface: {
          0:  'color-mix(in srgb, {primary.950}, white 100%)',
          50: 'color-mix(in srgb, {primary.950}, white 95%)',
          100:'color-mix(in srgb, {primary.950}, white 90%)',
          200:'color-mix(in srgb, {primary.950}, white 80%)',
          300:'color-mix(in srgb, {primary.950}, white 70%)',
          400:'color-mix(in srgb, {primary.950}, white 60%)',
          500:'color-mix(in srgb, {primary.950}, white 50%)',
          600:'color-mix(in srgb, {primary.950}, white 40%)',
          700:'color-mix(in srgb, {primary.950}, white 30%)',
          800:'color-mix(in srgb, {primary.950}, white 20%)',
          900:'color-mix(in srgb, {primary.950}, white 10%)',
          950:'color-mix(in srgb, {primary.950}, white 5%)',
        },
      },
      dark: {
        surface: {
          0:  'color-mix(in srgb, var(--surface-ground), white 100%)',
          50: 'color-mix(in srgb, var(--surface-ground), white 95%)',
          100:'color-mix(in srgb, var(--surface-ground), white 90%)',
          200:'color-mix(in srgb, var(--surface-ground), white 80%)',
          300:'color-mix(in srgb, var(--surface-ground), white 70%)',
          400:'color-mix(in srgb, var(--surface-ground), white 60%)',
          500:'color-mix(in srgb, var(--surface-ground), white 50%)',
          600:'color-mix(in srgb, var(--surface-ground), white 40%)',
          700:'color-mix(in srgb, var(--surface-ground), white 30%)',
          800:'color-mix(in srgb, var(--surface-ground), white 20%)',
          900:'color-mix(in srgb, var(--surface-ground), white 10%)',
          950:'color-mix(in srgb, var(--surface-ground), white 5%)',
        },
      },
    },
  },
} as const); 

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      appRoutes,
      withHashLocation(),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'top',
      }),
      withEnabledBlockingInitialNavigation()
    ),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([AuthInterceptor])),
    providePrimeNG({
      theme: { preset: MyPreset, options: { darkModeSelector: '.app-dark' } },
    }),
    MessageService,
  ],
};
